export default __webpack_public_path__ + "static/media/GF_POSTER_GROUP_01.a5a6bb47.jpg";